import { Dispatch } from 'redux';
import { PaginatedResponse } from '@synergy/api';

import { Api } from '../../../api';
import { AppState } from '../../../store/models/app-state';
import { Inquiry } from '../../../common/models/inquiry';

export const CLEAR_INQUIRY_DATA = 'CLEAR_INQUIRY_DATA';
export const DECLINE_INQUIRY = 'DECLINE_INQUIRY';
export const RECEIVE_INQUIRY_DATA = 'RECEIVE_INQUIRY_DATA';
export const REQUEST_INQUIRY_DATA = 'REQUEST_INQUIRY_DATA';
export const RESET_INQUIRIES = 'RESET_INQUIRIES';
export const SET_INQUIRY_PAGE = 'SET_INQUIRY_PAGE';
export const SET_INQUIRY_PAGE_SIZE = 'SET_INQUIRY_PAGE_SIZE';

const setInquiryToDeclined = (inquiryId: number) => {
    return {
        type: DECLINE_INQUIRY,
        inquiryId,
    };
};

export const requestInquiryData = () => {
    return {
        type: REQUEST_INQUIRY_DATA,
    };
};

export const receiveInquiryData = (data: PaginatedResponse<Inquiry>) => {
    return {
        type: RECEIVE_INQUIRY_DATA,
        data,
    };
};

export const clearInquiryData = () => {
    return { type: CLEAR_INQUIRY_DATA };
};

export const resetInquiries = () => {
    return { type: RESET_INQUIRIES };
};

export const fetchInquiries = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestInquiryData());

        const response = await api.inquiry.cget(searchParams);
        if (response.success) {
            dispatch(receiveInquiryData(response.result));
        }
    };
};

export const declineInquiry = (inquiryId: number, message: string) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(setInquiryToDeclined(inquiryId));
        await api.inquiry.decline(inquiryId, message);
    };
};
